import axios from 'axios'

import { getN8nWebhookUrl } from 'constants/n8n.constants'

export interface N8nWebhookPayload {
  [key: string]: any
}

export interface N8nWebhookResponse {
  success: boolean
  data?: any
  error?: string
}

export const createN8nApi = () => ({
  sendWebhook: (payload: N8nWebhookPayload): Promise<N8nWebhookResponse> =>
    axios
      .post(getN8nWebhookUrl() + '/paid_by_loan', payload, {
        headers: {
          'Content-Type': 'application/json',
        },
        timeout: 30000,
      })
      .then((response) => ({
        success: true,
        data: response.data,
      }))
      .catch((error) => ({
        success: false,
        error: error.message || 'Unknown error occurred',
      })),
})

export type N8nApi = ReturnType<typeof createN8nApi>
